import { name } from './constants';
import reducer from './reducer';
import TimeOverview from './TimeOverview';

export default {
  name,
  TimeOverview,
  reducer,
};



// WEBPACK FOOTER //
// ./src/sites/time/index.js